import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Divider, Drawer, IconButton, } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { useStore } from '@mcn-platform/models';
import { replaceStylesheetGlobals } from '@mcn-platform/converse-lib';
import CategoryMenu from './CategoryMenu';
import CategoryItem from './CategoryItem';
const MobileCategoryNav = ({ rootCategory, showSubCategoryDropdowns, editData }) => {
    const [open, setOpen] = useState(false);
    const store = useStore();
    const { currentPortal } = store;
    const storeStylesheet = currentPortal?.stylesheet;
    const location = useLocation();
    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);
    // Don't render if no categories exist
    if (!rootCategory || !rootCategory.subCategories || rootCategory.subCategories.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { "aria-label": "open drawer", onClick: () => setOpen(true), sx: {
                    // position: 'absolute',
                    top: 0,
                    left: 0,
                    display: {
                        xs: 'block',
                        sm: 'none',
                    },
                }, children: _jsx(MenuIcon, { sx: { width: '1.5em', height: '1.5em', color: replaceStylesheetGlobals(storeStylesheet, storeStylesheet?.menu?.menu?.font?.color) || '#FFFFFF' } }) }), _jsxs(Drawer, { open: open, anchor: "left", onClose: () => setOpen(false), PaperProps: {
                    sx: {
                        width: 350,
                        backgroundColor: replaceStylesheetGlobals(storeStylesheet, storeStylesheet?.site?.background?.color) || '#FFFFFF',
                    },
                }, children: [_jsx(IconButton, { sx: { mb: 1, justifyContent: 'end' }, onClick: () => setOpen(false), children: _jsx(CloseIcon, {}) }), _jsx(Divider, { sx: { mb: 2 } }), rootCategory && rootCategory.subCategories.map((category) => {
                        // console.log('check rootcategory', rootCategory);
                        if (showSubCategoryDropdowns && category.subCategories.length > 0) {
                            return (_jsx(CategoryMenu, { editData: editData, category: category }, category.id));
                        }
                        return (_jsx(CategoryItem, { category: category, editData: editData }, category.id));
                    })] })] }));
};
export default MobileCategoryNav;
//# sourceMappingURL=MobileCategoryNav.js.map